import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
const ContactUs = () => {
  return <div className="min-h-screen bg-white" data-id="element-316">
      <div className="bg-mwc-burgundy text-white py-12" data-id="element-317">
        <div className="container mx-auto px-4" data-id="element-318">
          <h1 className="text-3xl font-bold text-center mb-4" data-id="element-319">
            Contact Maplewood-Care
          </h1>
          <p className="text-lg text-center max-w-3xl mx-auto" data-id="element-320">
            We're here to help with all your appliance repair and maintenance
            needs
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-12" data-id="element-321">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-322">
          <div data-id="element-323">
            <div className="bg-mwc-lightpink p-8 rounded-lg shadow-md" data-id="element-324">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-6" data-id="element-325">
                Get in Touch
              </h2>
              <div className="space-y-6 mb-8" data-id="element-326">
                <div className="flex items-start" data-id="element-327">
                  <Phone className="text-mwc-burgundy mt-1 mr-4 flex-shrink-0" data-id="element-328" />
                  <div data-id="element-329">
                    <h3 className="font-semibold text-mwc-burgundy" data-id="element-330">Phone</h3>
                    <p className="text-gray-700" data-id="element-331">0800 055 4969</p>
                    <p className="text-sm text-gray-500" data-id="element-332">
                      Monday-Friday: 9:00am-7:00pm
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-333">
                      Saturday: 9:00am-2:00pm
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-334">Sunday: Closed</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-335">
                  <Mail className="text-mwc-burgundy mt-1 mr-4 flex-shrink-0" data-id="element-336" />
                  <div data-id="element-337">
                    <h3 className="font-semibold text-mwc-burgundy" data-id="element-338">Email</h3>
                    <p className="text-gray-700" data-id="element-339">support@maplewood-care.com</p>
                    <p className="text-sm text-gray-500" data-id="element-340">
                      We aim to respond within 24 hours
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-341">
                  <MapPin className="text-mwc-burgundy mt-1 mr-4 flex-shrink-0" data-id="element-342" />
                  <div data-id="element-343">
                    <h3 className="font-semibold text-mwc-burgundy" data-id="element-344">Address</h3>
                    <p className="text-gray-700" data-id="element-345">2B Westbury Ave</p>
                    <p className="text-gray-700" data-id="element-346">London, N22 6BS</p>
                    <p className="text-sm text-gray-500" data-id="element-347">United Kingdom</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-348">
                  <Clock className="text-mwc-burgundy mt-1 mr-4 flex-shrink-0" data-id="element-349" />
                  <div data-id="element-350">
                    <h3 className="font-semibold text-mwc-burgundy" data-id="element-351">
                      Business Hours
                    </h3>
                    <p className="text-gray-700" data-id="element-352">
                      Monday-Friday: 9:00am-7:00pm
                    </p>
                    <p className="text-gray-700" data-id="element-353">Saturday: 9:00am-2:00pm</p>
                    <p className="text-gray-700" data-id="element-354">Sunday: Closed</p>
                  </div>
                </div>
              </div>
              <div className="mt-8" data-id="element-355">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i3r48ZKNYAoPu74gxfDsXC/Maplewood_staff_fixing_TV.jpg" alt="Maplewood Care Engineer Fixing TV" className="max-w-xs mx-auto object-cover rounded-md shadow-md" data-id="element-356" />
              </div>
            </div>
          </div>
          <div data-id="element-357">
            <div className="bg-white p-8 rounded-lg shadow-md border border-gray-200" data-id="element-358">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-6" data-id="element-359">
                Send Us a Message
              </h2>
              <form className="space-y-6" data-id="element-360">
                <div data-id="element-361">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-362">
                    Your Name *
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-mwc-burgundy focus:border-mwc-burgundy" required data-id="element-363" />
                </div>
                <div data-id="element-364">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-365">
                    Email Address *
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-mwc-burgundy focus:border-mwc-burgundy" required data-id="element-366" />
                </div>
                <div data-id="element-367">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-368">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-mwc-burgundy focus:border-mwc-burgundy" data-id="element-369" />
                </div>
                <div data-id="element-370">
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-371">
                    Subject *
                  </label>
                  <input type="text" id="subject" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-mwc-burgundy focus:border-mwc-burgundy" required data-id="element-372" />
                </div>
                <div data-id="element-373">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-374">
                    Your Message *
                  </label>
                  <textarea id="message" rows={6} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-mwc-burgundy focus:border-mwc-burgundy" required data-id="element-375"></textarea>
                </div>
                <button type="submit" className="w-full bg-mwc-burgundy hover:bg-mwc-darkburgundy text-white font-semibold py-3 px-4 rounded-md transition-colors duration-300" data-id="element-376">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ContactUs;